import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { BackButton } from 'src/components/shared/BackButton'
import { Button } from 'src/components/shared/Button'
import { SectionCard } from 'src/components/shared/SectionCard'
import { SectionCardSkeleton } from 'src/components/shared/SectionCardSkeleton'

interface Props {
  isNotFound: boolean
  driverError: string | null
  isDriverLoading: boolean
  searchBackTo: { pathname: string; search: string }
  onRetry(): void
}

/** What the driver and steps pages show until a driver is loaded: not found, an error, or skeletons. */
const PartnerDriverLoadStateComponent = ({
  isNotFound,
  driverError,
  isDriverLoading,
  searchBackTo,
  onRetry,
}: Props) => {
  if (isNotFound) {
    return (
      <SectionCard title="Driver not found" dataTestId="partner-driver-not-found">
        <Typography variant="body2" css={tw`text-shades-500`}>
          No driver has this ID.
        </Typography>
        <BackButton label="Back to search" to={searchBackTo} />
      </SectionCard>
    )
  }

  if (driverError && !isDriverLoading) {
    return (
      <SectionCard
        title="Couldn't load the driver"
        actions={
          <Button size="small" color="grey" onClick={onRetry}>
            Retry
          </Button>
        }
      >
        <Typography variant="body2" css={tw`text-critical-500`}>
          {driverError}
        </Typography>
      </SectionCard>
    )
  }

  return (
    <div css={tw`grid grid-cols-1 items-start gap-6 lg:grid-cols-2`}>
      <SectionCardSkeleton fields={6} />
      <SectionCardSkeleton />
    </div>
  )
}

export const PartnerDriverLoadState = memo(PartnerDriverLoadStateComponent)
